import { __extends } from "tslib";
import { ErrorBase } from './ErrorBase';
var DocumentError = /** @class */ (function (_super) {
    __extends(DocumentError, _super);
    function DocumentError(message, id) {
        if (message === void 0) { message = 'DocumentError'; }
        if (id === void 0) { id = 0; }
        return _super.call(this, message, id) || this;
    }
    DocumentError.DOCUMENT_DOES_NOT_EXIST = 'documentDoesNotExist';
    return DocumentError;
}(ErrorBase));
export { DocumentError };
